import React from 'react'

export default function Licence() {
  return (
    <div className='historyWrap' id='license'>
      <span className='title'>04. LICENSE</span>
      <ul>
        <li><span>2024.12.11</span><p>정보처리 기사</p></li>
        <li><span>2024.12.13</span><p>SQL 개발자 (SQLD)</p></li>
        <li><span>2020.09.25</span><p>웹디자인 기능사</p></li>
      </ul>
    </div>
  )
}
